/* --------------------------------------------------------------------------------------
   xwPopover.js
   Copyright © 2023 Xerox Corporation. All Rights Reserved.
     
   Copyright protection claimed includes all forms and matters of copyrightable material
   and information now allowed by statutory or judicial law or hereinafter granted,
   including without limitation, material generated from the software programs which
   are displayed on the screen such as icons, screen display looks, etc.
--------------------------------------------------------------------------------------*/

import { useRef, useEffect } from "preact/hooks"
import { MFDApp } from "../../constants/MFDApp.const"

const XwPopover = props => {
    const elementRef = useRef(null)
    useEffect(() => {
        $(elementRef.current).xrxpopover(getOptions(props))
        if(props.hideWhileLoading){
            $(elementRef.current).show()
        }
        return () => $(elementRef.current).xrxpopover("destroy")
    }, [])
    return <div ref={elementRef} {...props.hideWhileLoading && {style:{display:"none"}}}>
        {props.children}
    </div>
}

const getOptions = props => ({
    ...props,
    theme: props.theme || MFDApp.theme,
    children: undefined
})

export default XwPopover